<app-header [data]="headerData"></app-header>
<div class="content" [@myAnimation]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>

